import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import useCommon from "hooks/useCommon";

const DeleteClientDialog = ({ open, onClose, onConfirm, clientId }) => {
  if (!open) return null;

  const { STORE } = useCommon();
  const { deleteLoading } = STORE((state) => state.clients);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth keepMounted>
      <DialogTitle sx={{ pb: 3, textAlign: "center" }}>
        <VuiTypography variant="button" fontWeight="bold">
          Delete Client
        </VuiTypography>
      </DialogTitle>

      <DialogContent>
        <VuiBox>
          <VuiTypography variant="body2">
            Are you sure you want to delete this client?
          </VuiTypography>
          <VuiTypography variant="caption" ml={0}>
            This action cannot be undone.
          </VuiTypography>
        </VuiBox>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <VuiButton variant="outlined" color="primary" type="button" onClick={onClose}>
          Cancel
        </VuiButton>

        <VuiButton
          variant="contained"
          color="error"
          type="button"
          disabled={deleteLoading}
          onClick={onConfirm}
        >
          {deleteLoading ? "Deleting..." : "Delete"}
        </VuiButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteClientDialog;
